import React from 'react';
import styles from './styles/SearchResults.module.css';

const SearchResults = ({ results, onSelect }) => {
  if (!results.length) return null;

  const handleClick = (e, location) => {
    e.preventDefault();
    e.stopPropagation();
    onSelect(location);
  };

  return (
    <div className={styles.resultsContainer}>
      {results.map((location, index) => (
        <div
          key={index}
          className={styles.resultItem}
          onClick={(e) => handleClick(e, location)}
          onMouseDown={(e) => e.preventDefault()}
        >
          <div className={styles.resultTitle}>{location.title}</div>
          <div className={styles.resultAddress}>{location.address}</div>
        </div>
      ))}
    </div>
  );
};

export default SearchResults; 